module.exports = __webpack_public_path__ + "static/media/Portrait-10206.72f93a7d.jpg";